import Splide from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import SimpleLightbox from "simplelightbox";

import './parts/facebook-feed-slider';
import './parts/menu';
import './parts/search';
import './parts/animations';

jQuery(function($) {

    // Image Gallery Lightbox
    function init_simple_lightbox(selector){
        var lightbox = new SimpleLightbox(selector, {
            animationSpeed: 100,
            fadeSpeed: 100,
            spinner: false,
            showCounter: false,
            caption: false,
            scrollZoom: false,
            navText: [ '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M234.8 36.25c3.438 3.141 5.156 7.438 5.156 11.75c0 3.891-1.406 7.781-4.25 10.86L53.77 256l181.1 197.1c6 6.5 5.625 16.64-.9062 22.61c-6.5 6-16.59 5.594-22.59-.8906l-192-208c-5.688-6.156-5.688-15.56 0-21.72l192-208C218.2 30.66 228.3 30.25 234.8 36.25z"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M85.14 475.8c-3.438-3.141-5.156-7.438-5.156-11.75c0-3.891 1.406-7.781 4.25-10.86l181.1-197.1L84.23 58.86c-6-6.5-5.625-16.64 .9062-22.61c6.5-6 16.59-5.594 22.59 .8906l192 208c5.688 6.156 5.688 15.56 0 21.72l-192 208C101.7 481.3 91.64 481.8 85.14 475.8z"/></svg>' ],
            closeText: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M420.7 36.69C426.9 30.44 437.1 30.44 443.3 36.69C449.6 42.93 449.6 53.06 443.3 59.31L246.6 256L443.3 452.7C449.6 458.9 449.6 469.1 443.3 475.3C437.1 481.6 426.9 481.6 420.7 475.3L224 278.6L27.31 475.3C21.07 481.6 10.94 481.6 4.686 475.3C-1.562 469.1-1.562 458.9 4.686 452.7L201.4 256L4.686 59.31C-1.562 53.07-1.562 42.94 4.686 36.69C10.93 30.44 21.06 30.44 27.31 36.69L224 233.4L420.7 36.69z"/></svg>'
        });
    }
    init_simple_lightbox('.wp-block-gallery .wp-block-image a');



    // Product page gallery slider
    function initialize__sliders(){

        // // Post selector block (Gutenberg block)
        // var category_sliders = document.querySelectorAll('.category-slider.splide');

        // for ( var i = 0; i < category_sliders.length; i++ ) {
        //     new Splide( category_sliders[ i ], {
        //         perPage: 6,
        //         perMove: 1,
        //         gap: '30px',
        //         pagination: false,
        //         type   : 'loop',
        //         padding: '9rem',
        //         heightRatio: 0.2,
        //         breakpoints: {
        //             1440: {
        //                 perPage: 4,
        //                 padding: '6rem',
        //                 heightRatio: 0.3,
        //             },
        //             800: {
        //                 perPage: 2,
        //                 padding: '4rem',
        //                 heightRatio: 0.6,
        //             }
        //         }
        //     } ).mount();
        // }
        
        // ACF Block: Icon Slider
        // https://splidejs.com/extensions/auto-scroll/
        var rolling_sliders = document.querySelectorAll('.icon-slider.splide');

        for ( var i = 0; i < rolling_sliders.length; i++ ) {
            new Splide( rolling_sliders[ i ], {
                // height: "150px",
                autoStart: false,
                type   : 'loop',
                perPage: 8,
                drag: 'free',
                focus  : 'center',
                pagination: false,
                arrows: false,
                gap: '38px',
                fixedWidth: '150px',
                pauseOnHover: false,
                pauseOnFocus: false,
                autoScroll: {
                    speed: 0.3,
                },
                breakpoints: {
                    800: {
                        perPage: 4,
                    },
                    600: {
                        perPage: 3,
                    },
                }
            } ).mount({ AutoScroll });
        }

    }
    initialize__sliders();


    // Scoll back to top of page
    document.getElementById('scroll-top').addEventListener('click', e => {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    })

    // Custom quantity buttons
    function listen_to_quantity_change(){

        let custom_quantity_buttons = document.querySelectorAll('.quantity .custom-quantity');
        
        if( ! custom_quantity_buttons ){
            return;
        }

        for (var i = 0; i < custom_quantity_buttons.length; i++) {
            const button = custom_quantity_buttons[i];
            button.addEventListener( 'click', function(e){
                var quantity = this.parentElement.querySelector('.qty');
                var value = parseInt(quantity.value);
                // update value
                quantity.value = this.classList.contains('plus') ? value += 1 : value -= 1;
                // allow cart update
                document.querySelector('button[name="update_cart"]').disabled = false;
                e.preventDefault();
            });
        }
    };
    listen_to_quantity_change(); // run it on page load
    $(document.body).on( 'updated_cart_totals', function(){ listen_to_quantity_change(); } ); // runs o

});

// Debounce function: waits for a certain amount of time before firing (used for the search input, waits until user stop typing)
function debounce(func, wait, immediate) {
    var timeout;
    return function executedFunction() {
        var context = this;
        var args = arguments;
            
        var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
        };
    
        var callNow = immediate && !timeout;
        
        clearTimeout(timeout);
    
        timeout = setTimeout(later, wait);
        
        if (callNow) func.apply(context, args);
    };
};

// For Google Lighthouse
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

window.addEventListener('load', function(){
    document.querySelector('body').classList.remove('preload');
});